module.exports = __webpack_public_path__ + "img/ferratum@2x.a185e14.png";